import { useContext } from 'react';
import { EditorContext, type EditorContextValue } from './EditorContext';

/**
 * Read the editor context. Throws if called outside the provider so that
 * tests + dev-time mistakes surface with a clear stack trace rather than a
 * silent `undefined.updateNodeData(...)`.
 */
export function useEditorContext(): EditorContextValue {
  const ctx = useContext(EditorContext);
  if (!ctx) {
    throw new Error(
      'useEditorContext must be used inside <EditorContextProvider>',
    );
  }
  return ctx;
}

/**
 * Non-throwing variant for components (e.g. the manual-completion modal)
 * that render both inside the editor and as page-level dialogs mounted
 * outside the provider. Returns {@code null} when no provider is present.
 */
export function useOptionalEditorContext(): EditorContextValue | null {
  return useContext(EditorContext) ?? null;
}
